import { mittInstance } from '@/constants/mitt-instance';
import { AppRouterInstance, NavigateOptions } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { usePathname, useRouter } from 'next/navigation';
import { useCallback, useMemo } from 'react';

export const useLoadingRouter = (): AppRouterInstance => {
  const router = useRouter();
  const pathname = usePathname();

  const replace = useCallback(
    (href: string, options?: NavigateOptions) => {
      if (href !== pathname) {
        mittInstance.emit('OPEN_SERVER_NAVIGATE_LOADING');
      }
      router.replace(href, options);
    },
    [router, pathname],
  );

  const push = useCallback(
    (href: string, options?: NavigateOptions) => {
      if (href !== pathname) {
        mittInstance.emit('OPEN_SERVER_NAVIGATE_LOADING');
      }

      router.push(href, options);
    },
    [router, pathname],
  );

  const memoValue = useMemo(() => ({ ...router, replace, push }), [router, replace, push]);

  return memoValue;
};
